import React from 'react';
import logoMark from '../images/image-removebg-preview.png';
import { metaTrackContact } from '../analytics/metaPixel';

function Footer() {
    return (
        <footer>
            <div className="footer-bottom">
                <div className="footer-brand">
                    <img src={logoMark} alt="GOUNOD" className="footer-logo" decoding="async" />
                </div>
                <div className="footer-contact-info">
                    <p><strong>Телефон:</strong> <a href="tel:+359879985171" onClick={() => metaTrackContact()}>+359 879 98 5171</a></p>
                    <p><strong>Имейл:</strong> <a href="mailto:ttashev16@gmail.com" onClick={() => metaTrackContact()}>ttashev16@gmail.com</a></p>
                </div>
                <p>Сайтът е създаден от <a href="https://myaibuilder.com" target="_blank" rel="noopener noreferrer">myaibuilder.com</a></p>
            </div>
        </footer>
    );
}

export default Footer;

